import iconSync from "assets/landing/token-utility/icon-sync.svg";
import iconCampaign from "assets/landing/token-utility/icon-campaign.svg";
import iconAccountBalance from "assets/landing/token-utility/icon-account-balance.svg";
import iconGasStation from "assets/landing/token-utility/icon-gas-station.svg";
import iconGavel from "assets/landing/token-utility/icon-gavel.svg";
import {
  GovernanceLine,
  NeoBankLine,
  DecentralizationLine,
  PaymentLine,
  AdvertisingCurrencyLine,
} from "assets/utility-lines";

export const UTILITY_ITEMS = [
  {
    id: "payment",
    title: "Payment Conversion Currency",
    icon: iconSync,
    desc: "Every payment inside the hub including agent fees, neobank transactions, on/off-ramp settles in $ATTS under the hood.",
    lineIcon: PaymentLine,
    linePosition: "translate-y-[49.2%]",
  },
  {
    id: "advertising",
    title: "Advertising Currency",
    icon: iconCampaign,
    desc: "All hub advertising placements, promoted agents, and sponsored campaigns are purchasable exclusively in $ATTS.",
    lineIcon: AdvertisingCurrencyLine,
    linePosition: "translate-y-[48.2%]",
  },
  {
    id: "neobank",
    title: "Neo-Bank & Staker Benefits",
    icon: iconAccountBalance,
    desc: "Staking $ATTS unlocks lower fees, premium neobank card tiers, and priority access to new agents.",
    lineIcon: NeoBankLine,
    linePosition: "",
  },
  {
    id: "gas",
    title: "Decentralization & Gas Fee",
    icon: iconGasStation,
    desc: "$ATTS covers gas for on-chain actions executed by your agents across supported chains.",
    lineIcon: DecentralizationLine,
    linePosition: "-translate-y-[50.4%]",
  },
  {
    id: "governance",
    title: "Governance",
    icon: iconGavel,
    desc: "$ATTS holders gain voting rights to shape the future of AGNT.Hub, influencing protocol upgrades, ecosystem incentives, and treasury allocation.",
    lineIcon: GovernanceLine,
    linePosition: "-translate-y-[50.4%]",
  },
];

export const getLinePosition = (position: "top" | "middle" | "bottom") => {
  switch (position) {
    case "top":
      return "translate-y-[50%]";
    case "middle":
      return "";
    case "bottom":
      return "-translate-y-[50%]";
    default:
      return "";
  }
};
